import React from "react";
import { View, StyleSheet } from "react-native";
import CardPlaceholder from "./CardPlaceholder";
import { ArticleCard } from "../../features/news-feed/components/article-card";
import ShareWrapper from "../ShareWrapper";
import { ARTICLE_HEIGHT } from "../../shared/constants/dimension";

const SPACING = 12;

export default function TemplateRow({ template, articles, fromRadio }: any) {
  const total = template.reduce((a, b) => a + b, 0);

  return (
    <View style={styles.row}>
      {template.map((span, index) => {
        const article = articles[index];
        return (
          <View
            key={index}
            style={[
              styles.cell,
              { flex: span / total },
              index === 0 && styles.firstCell,
              index === template.length - 1 && styles.lastCell,
            ]}
          >
            {article ? (
              <ShareWrapper>
                {() => (
                  <ArticleCard
                    article={article}
                    height={ARTICLE_HEIGHT}
                    fromRadio={fromRadio}
                  />
                )}
              </ShareWrapper>
            ) : (
              null
              /* <CardPlaceholder height={ARTICLE_HEIGHT} /> */
            )}
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    marginBottom: SPACING,
    paddingHorizontal: 10,
  },
  cell: {
    marginHorizontal: SPACING / 2,
  },
  firstCell: {
    marginLeft: 0,
  },
  lastCell: {
    marginRight: 0,
  },
});